import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const ClientInfosWrapper = styled.div`
  padding-bottom: 23px;
  display: flex;
`

export const ClientContentWrapper = styled.div`
  padding-bottom: 23px;
  display: flex;
`

export const ClientData = styled.div`
  width: 50%;
  background: white;
  border-radius: 4px;
  padding: 24px 24px 24px 21px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ClientLeftData = styled(ClientData)`
  margin-right: 16px;
`

export const ClientRightData = styled(ClientData)``

export const DisplayLess = styled.div`
  width: 100%;
  margin-top: 23px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  z-index: 100;

  & > a {
    color: ${colors.waterBlue};
    font-weight: 600;
    text-align: center;

    & > span {
      text-decoration: underline;
    }

    & > svg {
      margin-left: 5px;
      vertical-align: middle;
    }
  }

  @media(max-width: ${measures.tabletThreshold}px) {
    height: 56px;
    line-height: 56px;
    background: ${colors.lighterGrey};
    box-shadow: 0 2px 8px 1px ${colors.lightGrey};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`
export const ClientContentMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ClientDataMobile = styled.div`
  background: white;
  border-radius: 4px;
  padding: 11px 16px;
  margin-bottom: 68px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const StatusWrapper = styled.div`
  align-self: flex-end;
`
